module.exports = __webpack_public_path__ + "img/icon_modechoose_china.519d9a25.png";